module.exports = Em.Handlebars.compile("<div class=\"spinner\"><lucide-icon-module icon=\"loaderCircle\" /></div>\n{{text}}");